import { useShallow } from 'zustand/shallow';

import { useBatchedMeshInitialization } from 'app/modules/wallforming/components/scenes/objects/articles/hooks/useBatchedMeshInitialization';
import { useCameraLodSyncHandler } from 'app/modules/wallforming/components/scenes/objects/articles/hooks/useCameraLodSyncHandler';
import { useMaterialUpdateHandler } from 'app/modules/wallforming/components/scenes/objects/articles/hooks/useMaterialUpdateHandler';
import { useShadowsUpateHandler } from 'app/modules/wallforming/components/scenes/objects/articles/hooks/useShadowsUpateHandler';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

/**
 * Responsibilities:
 * - Initializes and manages the batched mesh objects for the navigator scene.
 * - Handles material and shadow updates for the navigator batched meshes.
 * - Retrieves and renders the navigator physical batched mesh from the placement store.
 * - Renders a Three.js primitive for the physical mesh (no event handlers attached - only for viewing).
 */
export const NavigatorBatchedMeshHandler = () => {
    useBatchedMeshInitialization({ isMainCanvas: false });
    useMaterialUpdateHandler({ isMainCanvas: false });
    useShadowsUpateHandler({ isMainCanvas: false });
    useCameraLodSyncHandler({ isMainCanvas: false });

    const navigatorBatchedMeshes = usePlacementStore(useShallow((state) => state.navigatorBatchedMeshes));

    if (!navigatorBatchedMeshes.physical) {
        return null;
    }

    return (
        <>
            <primitive object={navigatorBatchedMeshes.physical} />
            {navigatorBatchedMeshes.sheet && <primitive object={navigatorBatchedMeshes.sheet} />}
        </>
    );
};
